import type { PostMeta, PostModule } from '@/types/blog';

const modules = import.meta.glob<PostModule>('./blog/*.mdx', { eager: true });

export const posts: PostMeta[] = Object.entries(modules)
  .map(([path, mod]) => ({
    ...mod.frontmatter,
    filename: path.replace('./blog/', '').replace('.mdx', ''),
  }))
  .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

export function getPost(slug: string): PostModule | undefined {
  return Object.values(modules).find((mod) => mod.frontmatter.slug === slug);
}

export function formatDate(dateStr: string): string {
  return new Date(dateStr).toLocaleDateString('pl-PL', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}
